//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as d3 from 'd3';
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      COLOR: {
        PAIRS: '#6177dc',
        VOLUME: '#c0ccf9',
        SERVICE_FEE: '#afdafc',
        FEE: '#b69eff',
        PROFIT: '#000066',
      },
    };
  },

  computed: {
    ...mapState('statisticsTradeTurnoverTransactions', ['chartData']),

    data() {
      const { chart } = this;
      return !chart.length ? [] : chart.sort((a, b) => b.t - a.t);
    },

    yAxisInterval() {
      const { data } = this;
      const arr = [];

      data.forEach((e) => {
        arr.push(e.a);
        arr.push(e.p);
        arr.push(e.f);
        arr.push(e.r);
      });

      const min = Math.min.apply(null, arr);
      const max = Math.max.apply(null, arr);

      return [min, max];
    },

    getColorByTheme() {
      return this.$vuetify.theme.dark ? '#fff' : '#000';
    },
  },

  watch: {
    chart() {
      this.drawChart();
    },
  },

  async mounted() {
    await this.loadDataAction();
  },

  methods: {
    ...mapActions('statisticsTradeTurnoverTransactions', {
      loadDataAction: 'loadData',
    }),
    drawChart() {
      d3.selectAll('svg.chart-tradeturnover g').remove(); // remove all

      const {
        data,
        yAxisInterval,
        COLOR,
      } = this;
      const { clientWidth, clientHeight } = this.$refs.chartTradeTurnover;
      const margin = {
        top: 20,
        right: 20,
        bottom: 30,
        left: 80,
      };
      const width = clientWidth - margin.left - margin.right;
      const height = clientHeight - margin.top - margin.bottom;

      const svg = d3.select('svg.chart-tradeturnover');

      const g = svg.append('g')
        .attr('transform', `translate(${margin.left}, ${margin.top})`);

      // set x-axis scale
      const x = d3.scaleTime()
        .rangeRound([0, width]);

      // set y-axis scale
      const y = d3.scaleLinear()
        .rangeRound([height, 0]);

      // create graphs
      const volumeLine = d3.line()
        .x((d) => x(d.t))
        .y((d) => y(d.a1));

      const volumeFee = d3.line()
        .x((d) => x(d.t))
        .y((d) => y(d.a2));

      // set range
      x.domain(d3.extent(data, (d) => d.t));
      y.domain(yAxisInterval);

      g.append('g')
        .attr('transform', `translate(0, ${height})`)
        .call(d3.axisBottom(x));

      g.append('g')
        .call(d3.axisLeft(y))
        .append('text')
        .attr('fill', this.getColorByTheme)
        .attr('transform', 'rotate(-90)')
        .attr('y', 6)
        .attr('dy', '0.7em')
        .attr('text-anchor', 'end')
        .text(`in ${this.additionalChart.cumulativeCurrencyTitle}`);

      g.append('path')
        .datum(data)
        .attr('fill', 'none')
        .attr('stroke', COLOR.VOLUME)
        .attr('stroke-linejoin', 'round')
        .attr('stroke-linecap', 'round')
        .attr('stroke-width', 1.5)
        .attr('d', volumeLine);

      g.append('path')
        .datum(data)
        .attr('fill', 'none')
        .attr('stroke', COLOR.INCOME)
        .attr('stroke-linejoin', 'round')
        .attr('stroke-linecap', 'round')
        .attr('stroke-width', 1.5)
        .attr('d', volumeFee);
    },
  },
};
